import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { getUserProfile } from '../../ApiServices/GetUserProfileServices';
import { t } from 'i18next';

export const initialState = {
  value: undefined,
  loading: false,
  error: null,
  selectedValue: null,
  filter: [{}]
};

const getprofileSlice = createSlice({
  name: 'userProfile',
  initialState: initialState,
  reducers: {
    clearUserProfileState(state: any) {
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.filter = initialState.filter;
    }
  },
  extraReducers: builder => {
    builder.addCase(getProfile.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.value = action?.payload?.data;
    });
    builder.addCase(getProfile.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.value = initialState?.value;
    });
  }
});

export const getProfileState = (state: RootState) => state?.userProfile;
export const { clearUserProfileState } = getprofileSlice.actions;
export default getprofileSlice.reducer;

export const getProfile = createAsyncThunk(
  'profile/getuserprofile',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('GETUSER_PROFILE') }));
      let response = await getUserProfile(payload);
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
